<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="dedi">We respectfully dedicate this book to Ted Alexander and Ed Bearss, two great Civil War historians and authors we lost in 2020.</p>
<p class="dedi1">Both were valued mentors, consultants, colleagues, and, most of all, personal friends.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?031a74e2